import { withMotion } from '../hoc/with-motion';
import { OrgAddPodcast } from '@/modules/manager/components/org/add-podcast-page';

const AnimatedPage = withMotion(OrgAddPodcast);

export const roles: string[] = [];
export const path = '/manager/:orgId/add';
export const element = <AnimatedPage />